// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ActivityDefault } from '../../../assets/icons/default/general/activity.svg?react';
import { ReactComponent as ActivitySolid } from '../../../assets/icons/solid/general/ACTIVITY.svg?react';
import { createIcons } from '../../Icon';
const ActivityIcon = /* @__PURE__ */ createIcons('Activity', {
    default: ActivityDefault,
    solid: ActivitySolid
});
ActivityIcon.supportedTypes = ['default', 'solid'];
ActivityIcon.category = 'general';
export default ActivityIcon;
